import React from 'react'
import styles from './tags.module.scss'

export type Tag = {
  label: string
  tooltip?: string | number | null
}

interface Props {
  tags: Tag[]
}

export const Tags: React.FC<Props> = ({ tags }) => (
  <section className={styles.tagsSection}>
    <div className={styles.tags}>
      {tags.map((tag, index) => (
        <span key={index} className={styles.tag}>
          {tag.label}
          {tag.tooltip && <span className={styles.tooltip}>{tag.tooltip}</span>}
        </span>
      ))}
    </div>
  </section>
)
